import React, { useRef } from 'react'
import './IWW.css'
import ClickableImageCard from '../custom-components/ClickableImageCard';

function IndianWomenWear() {

const carouselRef = useRef(null);
        
    const scroll = (direction) => {
        const scrollAmount = 300;
        carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
        });
    };

    const deals = [
        {id: 1, bboo: "one", image: "https://assets.tatacliq.com/medias/sys_master/images/63588842897438.png"},
        {id: 2, bboo: "two", image: "https://assets.tatacliq.com/medias/sys_master/images/63588842962974.png"},
        {id: 3, bboo: "three", image: "https://assets.tatacliq.com/medias/sys_master/images/63588843028510.png"},
        {id: 4, bboo: "four", image: "https://assets.tatacliq.com/medias/sys_master/images/63588843094046.png"},
        {id: 5, bboo: "five", image: "https://assets.tatacliq.com/medias/sys_master/images/63588843159582.png"},
        {id: 6, bboo: "six", image: "https://assets.tatacliq.com/medias/sys_master/images/63588843225118.png"},
        {id: 7, bboo: "seven", image: "https://assets.tatacliq.com/medias/sys_master/images/63588843290654.png"},
    ];


    return (
        <div className="carousel-container">
          <div className="carousel-controls justify-content-end mb-5">
              <button onClick={() => scroll('left')} className="control-button">
                &lt;
              </button>
              <button onClick={() => scroll('right')} className="control-button">
                &gt;
              </button>
            </div>
          
          <div className="image-carousel" ref={carouselRef}>
            {deals.map((deal) => (
              <ClickableImageCard key={deal.id} item={deal} />
            ))}
          </div>
        </div>
      );
}

export default IndianWomenWear